import { max } from '../../utils/maxBy.js';
import { min } from '../../utils/minBy.js';
export const getLimitRangeByKeys = ([minKey, maxKey], limitParams, rateRows = []) => limitParams && limitParams[minKey] && limitParams[maxKey]
    ? {
        [minKey]: limitParams[minKey],
        [maxKey]: limitParams[maxKey],
    }
    : getRangeByKeys([minKey, maxKey], rateRows);
export const getRangeByKeys = ([minKey, maxKey], rows = []) => ({
    [minKey]: rows.length
        ? min(rows.filter((row) => typeof row[minKey] === 'number').map((row) => row[minKey]))
        : 0,
    [maxKey]: rows.length
        ? max(rows.filter((row) => typeof row[minKey] === 'number').map((row) => row[maxKey]))
        : 0,
});
export const checkRangeByKeys = (value, [minKey, maxKey], sourceBookRow) => value >= sourceBookRow[minKey] && value <= sourceBookRow[maxKey];
//# sourceMappingURL=rangeHelpers.js.map